'use client';

import { useQuery } from '@tanstack/react-query';
import { illustrationKeys } from '../queryKeys';
import { getIllustrations } from '../actions/getBooks';
import type { Illustration } from '../types';
import { whileWaiting } from '@/shared/hooks/liveRefetch';

const COVER_IN_FLIGHT_REFETCH_MS = 15_000;

export function useIllustrations(
  familyId: string | null | undefined,
  filters?: { onlyFavorites?: boolean },
) {
  return useQuery<Illustration[]>({
    queryKey: illustrationKeys.list(familyId ?? '', filters),
    queryFn: () => getIllustrations({ onlyFavorites: filters?.onlyFavorites }),
    enabled: !!familyId,
    staleTime: 30_000,
    refetchInterval: (query) => {
      const illustrations = query.state.data ?? [];
      const hasInFlightCover = illustrations.some(
        (b) => b.coverImageStatus === 'queued' || b.coverImageStatus === 'generating',
      );
      // books.cover.* events invalidate this list; the interval is only the fallback
      return whileWaiting(hasInFlightCover, COVER_IN_FLIGHT_REFETCH_MS);
    },
  });
}
